import customAxios           from '../../customAxios';
import { LOCATION_PROVINCE } from '../../routes';
import { locationNamespace } from '../../../types/location.namespace';

async function createProvince(props: locationNamespace.province.create) {
  try {
    return (await customAxios.post(LOCATION_PROVINCE, props)).data;
  } catch (error: any) {
    console.error({LOCATION_PROVINCE: error});
  }
}

export default createProvince;
